/**
 * @file 新建图表浮窗游戏选择器触发按钮（Layer 1 纯 UI）。
 * 由 `ChartGameSelect` 作为 Tea `Dropdown` 的 `button` 插槽渲染。
 */
import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import TextBubbles from '@home/components/TextBubbles';
import { CHART_GAME_LIST_TEXT_BUBBLE_PROPS } from '../bubbleOverlay';
import type { IGameSelectTriggerProps } from '../types';

/**
 * 游戏下拉触发按钮。
 *
 * 视觉对齐 Figma「已选游戏」：40px 外框、左侧 label + icon + 文案、右侧下拉箭头。
 *
 * @param props - 触发器属性，见 {@link IGameSelectTriggerProps}
 *
 * @remarks
 * - 未选中时展示 `placeholder`；选中后展示 `selectedOption` 的 icon 与 text
 * - 样式类名前缀为 `dba-new-chart-game-trigger`，不依赖 `db-single-select-button`
 */
const GameSelectTrigger: React.FC<IGameSelectTriggerProps> = ({
  name,
  placeholder,
  selectedOption,
}) => (
  <div className="dba-new-chart-game-trigger">
    <div className="dba-new-chart-game-trigger__content">
      {name ? (
        <span className="dba-new-chart-game-trigger__label">{name}</span>
      ) : null}
      {selectedOption ? (
        <span className="dba-new-chart-game-trigger__value">
          {selectedOption.icon ? (
            <img src={String(selectedOption.icon)} alt="" />
          ) : null}
          <TextBubbles
            text={selectedOption.text}
            rowNum={1}
            placement="top"
            className="dba-new-chart-game-trigger__value-text"
            bubbleProps={CHART_GAME_LIST_TEXT_BUBBLE_PROPS}
          />
        </span>
      ) : (
        <span className="dba-new-chart-game-trigger__placeholder">
          {placeholder}
        </span>
      )}
    </div>
    <span className="dba-new-chart-game-trigger__arrow" aria-hidden>
      <SvgIcon type="arrow-down" />
    </span>
  </div>
);

export default GameSelectTrigger;
